import { ReactComponent as Operator } from '../../../../assets/Operator.svg';
import styled from '../../../../lib/theme';

export const OperatorOnIcon = styled(Operator)`
  ${({ theme }) => `
    * {
      fill: ${theme.sendButtonBackgroundColor || theme.primaryAccentColor};
      #Group {
        fill: ${theme.sendButtonBackgroundColor || theme.primaryAccentColor};
      }
    }
  `}
`;

export const OperatorOffIcon = styled(Operator)`
  ${({ theme }) => `
    * {
      fill: ${'#ddd'};
      #Group {
        fill: ${'#ddd'};
      }
    }
  `}
`;
